<template>
    <sidebar-menu :items="items" has-icon :force-expanded="forceExpanded" @update:expanded="$emit('update:expanded', $event)" />
</template>

<script>
import { mapState } from 'vuex';
import SidebarMenu from '@/components/sidebar/SidebarMenu.vue';
import TermSchedule from '@/models/term-schedule/TermSchedule.js';

export default {
    name: 'GroupSidebar',

    components: { SidebarMenu },

    emits: ['update:expanded'],

    data: () => ({
        hasTermSchedule: false,
    }),
    props: {
        forceExpanded: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        ...mapState('Auth', { user: state => state.user }),

        groupId() {
            return parseInt(this.$route.params.groupId, 10);
        },

        hasValidGroupId() {
            return Number.isFinite(this.groupId);
        },

        activePageFolder() {
            return this.$store.state.entities.dashboard.activePageFolder;
        },

        items() {
            // While navigating away from /groups/:groupId (e.g. Administration →
            // Groups), this computed re-runs before the sidebar unmounts. At that
            // point route.params.groupId is gone, so group-* RouterLinks would
            // throw "Missing required param 'groupId'". Render nothing until a
            // valid group context exists again.
            if (!this.hasValidGroupId) {
                return [];
            }

            const { groupId } = this.$route.params;
            const groupsMenuOptions = [
                {
                    type: 'item',
                    title: 'Members',
                    route: { name: 'group-view', params: { groupId } },
                    canSee: this.$gate.allows('view', ['Status']),
                    icon: 'user',
                },
                {
                    type: 'item',
                    title: 'Courses',
                    route: { name: 'group-courses-view', params: { groupId } },
                    canSee: this.$gate.allows('view', ['Status']),
                    icon: 'book',
                },
                {
                    type: 'item',
                    title: 'Evaluations',
                    route: {
                        name: 'group-evaluations-view',
                        params: { groupId },
                    },
                    canSee: this.$gate.allows('view', ['Status']),
                    icon: 'clipboard',
                },
            ];

            const termsMenuOption = [
                {
                    type: 'folder',
                    title: 'Terms',
                    hasIcon: true,
                    icon: 'folder',
                    displayItemsAlways: true,
                    items: [
                        {
                            type: 'item',
                            title: 'Templates',
                            route: {
                                name: 'group-term-templates-index',
                                params: { groupId },
                            },
                            canSee: this.$gate.allows('view', ['TermTemplate']),
                        },
                        {
                            type: 'item',
                            title: 'Schedules',
                            route: {
                                name: 'group-term-schedules-index',
                                params: { groupId },
                            },
                            canSee: this.$gate.allows('view', ['TermSchedule']),
                        },
                        {
                            type: 'item',
                            title: 'Assigned Schedules',
                            route: {
                                name: 'assigned-group-term-schedule-index',
                                params: { groupId },
                            },
                            canSee: true,
                            icon: 'list-ul',
                        },
                    ],
                    canSee: this.$gate.allows('view', ['TermTemplate']),
                },
            ];

            // return Group.find(this.$route.params.groupId)?.has_terms
            //     ? [...groupsMenuOptions, ...termsMenuOption]
            //     : groupsMenuOptions;
            return [...groupsMenuOptions, ...termsMenuOption];
        },
    },

    async created() {
        if (!this.hasValidGroupId) {
            return;
        }

        await TermSchedule.fetchGroupTermSchedules(this.groupId);

        this.hasTermSchedule = !!TermSchedule.query().where('group_id', this.groupId).count();
    },
};
</script>
